// extracted by mini-css-extract-plugin
module.exports = {"card":"x7mnot","withBg":"_3_ceOg","withShadow":"YUUcvK","size-sm":"psX9Qt","size-md":"_19WCpa"};